import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../../_services/loader/loader.service';
import { Utilitarios } from '../../_common/utilitarios.common';
import { timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class httpInterceptor implements HttpInterceptor {
  private requests: string[] = [];

  private readonly publicNoAuthUrls = [
    '/api/LinksCompartilhados/Visualizar',
    '/api/LinksCompartilhados/VisualizarResultados'
  ];

  /** Requisições autenticadas em background — não exibem overlay "Carregando..." */
  private readonly silentLoaderUrlPatterns = [
    '/api/UiTheme/'
  ];

  constructor(private loaderService: LoaderService, private router: Router) { }

  removeRequest(req: string) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(request: HttpRequest<any>, newRequest: HttpHandler): Observable<HttpEvent<any>> {
    const isPublicNoAuth = this.publicNoAuthUrls.some(url => request.url.includes(url));
    const skipLoader = this.silentLoaderUrlPatterns.some(url => request.url.includes(url))
      || request.headers.has('X-Skip-Loader');

    if (isPublicNoAuth) {
      return newRequest.handle(request);
    }

    const authedRequest = this.attachAuthHeaders(request);
    return this.handleRequest(authedRequest, newRequest, !skipLoader);
  }

  private handleRequest(
    request: HttpRequest<any>,
    next: HttpHandler,
    showLoader: boolean
  ): Observable<HttpEvent<any>> {
    const trackKey = `${request.method}:${request.url}`;

    if (showLoader) {
      this.requests.push(trackKey);
      this.loaderService.isLoading.next(true);
    }

    return new Observable<HttpEvent<any>>(observer => {
      const subscription = next.handle(request).pipe(timeout(180000)).subscribe(
        event => {
          if (event instanceof HttpResponse) {
            if (showLoader) {
              this.removeRequest(trackKey);
            }
            observer.next(event);
          }
        },
        err => {
          if (showLoader) {
            this.removeRequest(trackKey);
          }
          observer.error(err);
        },
        () => {
          if (showLoader) {
            this.removeRequest(trackKey);
          }
          observer.complete();
        }
      );

      return () => {
        if (showLoader) {
          this.removeRequest(trackKey);
        }
        subscription.unsubscribe();
      };
    });
  }

  private attachAuthHeaders(request: HttpRequest<any>): HttpRequest<any> {
    const util = new Utilitarios();
    const tokenInfo = util.RetornarLocalStorageAutenticacao();
    const original = util.RetornarAutenticacaoOriginal();
    const impersonacao = util.RetornarImpersonacao();
    const tokenSource = (impersonacao && original?.dsToken) ? original : tokenInfo;

    if (!tokenSource?.dsToken) {
      return request;
    }

    if (this.isTokenExpired(tokenSource.dsToken)) {
      util.RemoverItemLocalStorageAutenticacao();
      this.router.navigate(['/pages/login']);
      return request;
    }

    const setHeaders: { [name: string]: string } = {
      Authorization: `Bearer ${tokenSource.dsToken}`
    };

    if (impersonacao?.id) {
      setHeaders['X-Impersonate-UserId'] = String(impersonacao.id);
    }

    return request.clone({ setHeaders });
  }

  private isTokenExpired(token: string): boolean {
    try {

      const decoded: any = this.parseJwt(token);
      const exp = decoded.exp;
      if (!exp) return true;

      const now = Math.floor(Date.now() / 1000);

      return exp < now;
    } catch (e) {
      return true; // erro ao decodificar = token inválido
    }
  }

  private parseJwt(token: string): any {
    try {

      const base64Payload = token.split('.')[1];
      const payload = atob(base64Payload);

      return JSON.parse(payload);

    } catch (e) {
      return null;
    }
  }
}
